export const GLOBAL_SEARCH_TYPE_ID = 9;